// /**
//  * @file
//  * ibotheme behaviors.
//  */


import FitMenu from './FitMenu.js'

let fitMenu = new FitMenu('#block-hoofdnavigatie .menu-item a');
fitMenu.init();

let fitContact = new FitMenu('.node-26 h1');
fitContact.init();





(function ($, Drupal) {

  'use strict';

  $('#block-ibotheme-main-menu').meanmenu({
    meanMenuContainer: '.ibo-header',
    meanMenuOpen: "<span></span><span></span><span></span>",
    meanScreenWidth: "1024"
  });


  /**
   * Behavior description.
   */
  Drupal.behaviors.ibotheme = {
    attach: function (context, settings) {


      // Use querySelector for modern, robust selection
      let menu = document.querySelector('.language-switcher-language-url');

      if (menu && !menu.classList.contains('ibotheme-processed')) {
        // Iterate over li elements inside the menu
        menu.querySelectorAll('li').forEach(function(li) {


          // check if href equals html lang
          if(li.getAttribute('hreflang') === document.documentElement.lang) {
            // If it does, add the 'is-active' class
            li.classList.add('is-active');
            return; // Exit the loop early since we found the match
          }


        });
        menu.classList.add('ibotheme-processed');
      }


      $('.caption-drupal-media').each(function() {
        let article = $(this).find($('article'));
        if (article.hasClass('media--view-mode-halve-breedte')) {
          article.addClass('processed');
          $(this).addClass('halve-breedte');
        }
      });
      $('.field--name-body article').each(function() {
        if(!$(this).hasClass('processed')) {
          if ($(this).hasClass('media--view-mode-halve-breedte')) {
            $(this).addClass('halve-breedte');
          }
        }
      });



    }
  };

}(jQuery, Drupal));
